<template>
  <div>
    <v-card flat>
      <v-data-table
        :headers="headers"
        :loading="loadingMessage"
        :items="businessClient"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">
            {{ props.item.user_provider_wesmart_first_name
            }}<span class="ml-2">{{
              props.item.user_provider_wesmart_last_name
            }}</span>
          </td>

          <td class="text-xs-center">
            {{ props.item.user_provider_wesmart_we_credit }}
          </td>
          <td class="text-xs-center">
            {{
              props.item.user_provider_wesmart_email == null
                ? "-"
                : props.item.user_provider_wesmart_email
            }}
          </td>
          <td class="text-xs-center">
            {{ moment(props.item.create_at).format("YYYY/MM/DD HH:mm:ss") }}
          </td>
          <td class="text-xs-center">
            <v-btn icon @click="businessDeatil(props.item)">
              <v-icon small>remove_red_eye</v-icon>
            </v-btn>
          </td>
        </template>
        <template slot="no-data"></template>
      </v-data-table>
      <v-snackbar v-model="errSnackbar" color="black" :timeout="3000">
        <v-icon color="red">close</v-icon>
        {{ snackBarMsg || "มีบางอย่างผิดพลาด!" }}
        <v-btn dark flat @click="errSnackbar = false"> Close </v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import moment from "moment";
export default {
  props: ["searchLog"],
  data: () => ({
    search: "",
    loadingMessage: false,
    pagination: {
      rowsPerPage: 10,
    },
    headers: [
      {
        text: "Owner",
        value: "user_provider_wesmart_first_name",
        sortable: false,
        align: "center",
      },
      {
        text: "Credit",
        value: "user_provider_wesmart_we_credit",
        sortable: false,
        align: "center",
      },
      {
        text: "Email",
        sortable: false,
        value: "user_provider_wesmart_email",
        align: "center",
      },
      {
        text: "Date/Time",
        sortable: false,
        value: "create_at",
        align: "center",
      },
      {
        text: "Transaction",
        value: "",
        sortable: false,
        align: "center",
      },
    ],
    errSnackbar: false,
    snackBarMsg: null,
    data_loading: false,
  }),
  computed: {
    ...mapState({
      businessClient: (state) => state.Business.businessClient,
    }),
  },
  methods: {
    ...mapActions({
      getbankDetail: "banklist/fetchBankByid",
    }),
    async getData() {
      this.loadingMessage = true;
      await this.$store.dispatch("Business/fetchBusinesslist_client");
      this.loadingMessage = false;
    },
    async businessDeatil(item) {
      if (!item) return;
      this.$router.push({
        name: "businessclient_id",
        params: {
          business_id: item.user_provider_wesmart_id,
          firstname: item.user_provider_wesmart_first_name,
          lastname: item.user_provider_wesmart_last_name,
        },
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style>
.badge_status--active {
  color: #fbd200;
}
.badge_status--inactive {
  color: #4caf50;
}
.badge_status--reject {
  color: #fb3200;
}
.badge_status--delete {
  color: #9b9a99;
}
</style>
